/**
 * Per-page-session cache for the take-home claim map (#4010 PR-B), shared by
 * components/debrief/ClaimMap.jsx and contexts/AuthContext.jsx (logout wipes
 * it, so one learner's map never survives to the next sign-in on a shared
 * device). Lives in utils/ so AuthContext does not import a component.
 *
 * Writer: ClaimMap's poll. Reader: ClaimMap. Compaction: entries are tiny and
 * die with the page; invalidated by signature change (see ClaimMap), run
 * status 'active', and logout. Scope: this tab, memory only.
 */
/** runId -> { sig, map?, terminal? } */
export const claimMapSessionCache = new Map();
/** runIds whose claim_map_viewed already fired this page session. */
export const claimMapViewedRuns = new Set();

export function clearClaimMapSession() {
  claimMapSessionCache.clear();
  claimMapViewedRuns.clear();
}
